<script>
import HotelCard from 'components/views/my/hotels/thumbs/Hotel.svelte';


import SvelteSeo from 'svelte-seo';


const hotels = [
	{
		href: '/files/hotels/MIRA2025.xls',
		city: 'Miramichi Hotels',
	},
	{
		href: '/files/hotels/HALIFAX2025.xlsx',
		city: 'Halifax Hotels',
	},
	{
		href: '/files/hotels/CHAR2025.xlsx',
		city: 'Charlottetown Hotels',
	},
	{
		href: '/files/hotels/MONCTON2025.xls',
		city: 'Moncton Hotels',
	},
	{
		href: '/files/hotels/SUMMERSIDE2025.xls',
		city: 'Summerside Hotels',
	},
	{
		href: '/files/hotels/SYDNEY2025.xls',
		city: 'Sydney Hotels',
	},
	{
		href: '/files/hotels/FRED2025.xls',
		city: 'Fredericton Hotels',
	},
	{
		href: '/files/hotels/BATH2025.xls',
		city: 'Bathurst Hotels',
	},
	// {
	// 	// href: 'https://docs.google.com/spreadsheets/d/1bsao-F9QOpS9hPo029UVp_bjvFi1BwTX8ocNyLHuJNA/edit#gid=286095924',
	// 	href: 'https://docs.google.com/spreadsheets/d/1YXYITAe5_Kd1qF-Gp2M2wH7ayHfrYMBj/edit?usp=sharing&ouid=102405300104587443692&rtpof=true&sd=true',
	// 	city: 'Halifax Hotels',
	// },
	// {
	// 	href: 'https://docs.google.com/spreadsheets/d/1iK8PErZ6TxHVgYPo6mj-wt4AuM2Rzlu6/edit?usp=sharing&ouid=102405300104587443692&rtpof=true&sd=true',
	// 	city: 'Saint John Hotels',
	// },
	// {
	// 	href: 'https://docs.google.com/spreadsheets/d/16dMqy-975BA9zAj53cMhTx8_MpeXiwCNAXSwvPs_UJs/edit?usp=sharing',
	// 	city: 'PEI Hotels',
	// },
	// {
	// 	href: 'https://docs.google.com/spreadsheets/d/1AvpDdt00vdP-hTw4SsEI8SxTNdVnWOnh5j5Rmjyz7Bg/edit?usp=sharing',
	// 	city: 'Young Guns Accommodations (2022)',
	// },
	// {
	// 	href: 'https://docs.google.com/spreadsheets/d/1P7ptM9sv0EUmBeU5liAPnLOAcoQBYuCC/edit?usp=sharing&ouid=102405300104587443692&rtpof=true&sd=true',
	// 	city: 'Moncton Summer Jamboree',
	// },
]



</script>


<style>
	

</style>



<SvelteSeo
	title='Hotels | AHG Coaches Portal'
	description='Hotels!'
/>



<section class="hero bg-grey">

	<div class="hero-body">

		<div class="container">

			<p class="hero-subtitle has-text-centered">
				Hotels
			</p>

		</div>

	</div>
	
</section>



<section class="section">

	<div class="container">

		<div class="columns is-centered">

			<div class="column is-9-desktop is-10-tablet is-12-mobile">

				<div class="columns is-variable is-3 is-mobile is-multiline is-centered">

					{#each hotels as hotel}

						<div class="column is-6-desktop is-12-touch">

							<HotelCard {hotel} />

						</div>

					{/each}

				</div>

			</div>

		</div>

	</div>

</section>

<!-- email: donotreply@atlantichockeygroup.com -->






